import apiClient from './client';

export interface MaintenanceFeeChargeAttempt {
  id: string;
  clientId: string;
  clientName?: string;
  feeType: 'MAINTENANCE_FEE' | 'ONBOARDING_FEE';
  feeRuleId?: string | null;
  billingPeriodFrom: string; // DateOnly as ISO string
  billingPeriodTo: string;
  scheduledChargeDate: string;
  chargeAttemptedAt?: string | null;
  chargeStatus: 'PENDING' | 'CHARGED' | 'SKIPPED' | 'FAILED';
  skipReason?: string | null;
  primaryAccountId?: string | null;
  primaryAccountCurrency?: string | null;
  linkedAccountId?: string | null;
  chargedLedgerTransactionId?: string | null;
  feeAmount?: number | null;
  feeCurrency?: string | null;
  chargeAmount?: number | null;
  chargeCurrencyId?: string | null;
  notes?: string | null;
  createdAt: string;
}

export interface CreateMaintenanceFeeRequest {
  clientId: string;
  clientAccountId: string;
  billingPeriodFrom: string; // yyyy-MM-dd
  billingPeriodTo: string;
  scheduledChargeDate: string;
  feeType: 'MAINTENANCE_FEE' | 'ONBOARDING_FEE';
  chargeAmount: number;
  chargeCurrencyId: string;
  feeRuleId?: string;
  notes?: string;
}

export interface SkipMaintenanceFeeRequest {
  reason: string;
}

export const maintenanceFeeApi = {
  getAll: (limit = 500) =>
    apiClient.get<MaintenanceFeeChargeAttempt[]>('/MaintenanceFee', { params: { limit } }),

  getById: (id: string) =>
    apiClient.get<MaintenanceFeeChargeAttempt>(`/MaintenanceFee/${id}`),

  getPending: (limit = 200) =>
    apiClient.get<MaintenanceFeeChargeAttempt[]>('/MaintenanceFee/pending', { params: { limit } }),

  getCharged: (limit = 200) =>
    apiClient.get<MaintenanceFeeChargeAttempt[]>('/MaintenanceFee/charged', { params: { limit } }),

  getSkipped: (limit = 200) =>
    apiClient.get<MaintenanceFeeChargeAttempt[]>('/MaintenanceFee/skipped', { params: { limit } }),

  getByClientId: (clientId: string, limit = 100) =>
    apiClient.get<MaintenanceFeeChargeAttempt[]>(`/MaintenanceFee/client/${clientId}`, { params: { limit } }),

  schedule: (data: CreateMaintenanceFeeRequest) =>
    apiClient.post<MaintenanceFeeChargeAttempt>('/MaintenanceFee/schedule', data),

  charge: (id: string) =>
    apiClient.post(`/MaintenanceFee/${id}/charge`),

  skip: (id: string, data: SkipMaintenanceFeeRequest) =>
    apiClient.post(`/MaintenanceFee/${id}/skip`, data),

  processDue: () =>
    apiClient.post<{ processed: number }>('/MaintenanceFee/process-due'),
};
